<template>
    <b-card no-body>
        <b-card-header class="p-2">
            <h4 class="mb-0">Upload Documents</h4>
        </b-card-header>
        <div class="p-3">
            <b-row>
                <b-col lg="6">
                    <vue-dropzone id="consentFormDropzone" 
                        ref="consentFormDropzone"
                        :options="dropzoneOptions" 
                        :useCustomSlot=true
                        v-on:vdropzone-file-added="dropzoneAddedConsentForm"
                        v-on:vdropzone-removed-file="dropzoneRemovedConsentForm"
                    >
                        <b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
                        <p class="mb-0">Drop files here</p>
                    </vue-dropzone>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Select Document Type">
                        <el-select v-model="doc_type" placeholder="Select" class="mx-2">
                            <el-option
                            v-for="item in docTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </b-form-group>
                    <b-form-group label="Remarks (Optional)">
                        <b-form-textarea
                        v-model="remarks"
                        placeholder="Write remarks here..."
                        rows="3"
                        max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row align-h="between" align-v="center" >
                <b-col cols="auto" class="d-flex align-items-center">
                    <b-form-input
                        v-model="searchDoc"
                        placeholder="Search Receipt No, Remar..."
                    >
                    </b-form-input>	
                    <el-select v-model="doc_type" placeholder="Select" class="mx-2">
                        <el-option
                        v-for="item in docTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
                <b-col cols="auto">
                    <el-date-picker
                    v-model="date_filter"
                    type="date"
                    placeholder="Pick a day"
                    class="mx-2"
                    ></el-date-picker>
                </b-col>
            </b-row>

            <b-row class="my-3">
                <b-col cols="12">
                    <h4 class="mb-0">Uploaded Documents (2)</h4>
                </b-col>
            </b-row>

            <div class="card-table-simple">
                <b-table-simple responsive class="mb-0">
                    <b-thead>
                        <b-tr>
                            <b-th>Name</b-th>
                            <b-th>Doc Type</b-th>
                            <b-th>Remarks</b-th>
                            <b-th>Uploaded by</b-th>
                            <b-th>Date</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(data, index) in tableData" :key="index">
                            <b-td>{{ data.name }}</b-td>
                            <b-td>{{ data.doc_type }}</b-td>
                            <b-td>{{ data.remarks }}</b-td>
                            <b-td>{{ data.uploaded_by }}</b-td>
                            <b-td>{{ data.uploaded_on }}</b-td>
                            <b-td class="text-danger">
                                <svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer" width="12" height="16" viewBox="0 0 448 512"><path fill="currentColor" d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"/></svg>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>
        </div>
    </b-card>
</template>
<script>
import { Option, Select, DatePicker } from 'element-ui'
import vue2Dropzone from 'vue2-dropzone'

export default {
    components: {
        vueDropzone: vue2Dropzone,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            dropzoneOptions: {	
                url: '#',
                addRemoveLinks: true,
                maxFiles: 1,
                autoProcessQueue: false,
                acceptedFiles: "application/pdf",
            },
            remarks: '',
            doc_type: '',
            docTypeList: [
                {
                    value:  'Payslip',
                    label:  'Payslip'
                }
            ],
            date_filter: '',
            searchDoc: '',
            tableData: [
                {
                    name: 'ralph_edwards_IC.pdf',
                    doc_type: 'NRIC',
                    remarks: 'Remarks are here',
                    uploaded_by: 'Mena Tan',
                    uploaded_on: '10 May 2023',
                },
                {
                    name: 'jan2023_payslip.pdf',
                    doc_type: 'Payslip',
                    remarks: 'Lorem ipsum mortie velit',
                    uploaded_by: 'Mena Tan',
                    uploaded_on: '10 May 2023',
                }
            ]
        }
    },
    methods: {
        dropzoneAddedConsentForm(file){
            this.form.consent_form = file
        },
        dropzoneRemovedConsentForm(file, error, xhr){
            this.form.consent_form = null
        },
    }
}
</script>